import { BasePrescriptionTemplate } from './BasePrescriptionTemplate';
import type { PrescriptionPrintTemplateProps } from '../types';

const extractPediatricsSummary = (specialtyData: Record<string, unknown> | null): string | null => {
  if (!specialtyData) return null;

  const pediatric = specialtyData.pediatric;
  if (!pediatric || typeof pediatric !== 'object') return null;

  const alerts = (pediatric as { alerts?: unknown }).alerts;
  if (typeof alerts !== 'string' || alerts.trim() === '') return null;

  return `Pediatría (alertas): ${alerts.trim()}`;
};

export function PediatricsPrescriptionTemplate(props: PrescriptionPrintTemplateProps) {
  const pediatricsSummary = extractPediatricsSummary(props.specialtyData);

  if (!pediatricsSummary) {
    return <BasePrescriptionTemplate {...props} />;
  }

  const mergedRecommendations = props.consultation.general_recommendations
    ? `${pediatricsSummary}\n${props.consultation.general_recommendations}`
    : pediatricsSummary;

  return (
    <BasePrescriptionTemplate
      {...props}
      consultation={{
        ...props.consultation,
        general_recommendations: mergedRecommendations,
      }}
    />
  );
}
